import ShopgateAuthFacebookReducer from '@shopgate/auth-facebook/frontend/reducers/index.js';

export default {
  '@shopgate/auth-facebook/Reducer': ShopgateAuthFacebookReducer,
};
